// import React, { Component } from "react";
// import { Link } from "react-router-dom";
// import parse from "html-react-parser";

// class SolarInverterDetails extends Component {
//   render() {
//     let publicUrl = process.env.PUBLIC_URL + "/";

//     return (
//       <div className="ltn__shop-details-area pb-10">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-8 col-md-12">
//               <div className="ltn__shop-details-inner ltn__page-details-inner mb-60">
//                 <div className="ltn__blog-meta">
//                   <ul>
//                     <li className="ltn__blog-category">
//                       <Link to="#">Power your life with Atom Power</Link>
//                     </li>
//                     <li className="ltn__blog-category">
//                       <Link className="bg-orange" to="#">
//                         ATP Series Solar Inverters
//                       </Link>
//                     </li>
//                     {/* <li className="ltn__blog-date">
//                       <i className="far fa-calendar-alt" />
//                       May 19, 2021
//                     </li>
//                     <li>
//                       <Link to="#">
//                         <i className="far fa-comments" />
//                         35 Comments
//                       </Link>
//                     </li> */}
//                   </ul>
//                 </div>
//                 <h1>Solar Inverters</h1>
//                 <label>
//                   <span className="ltn__secondary-color">
//                     <i className="flaticon-pin" />
//                   </span>
//                   A Smart Battery Solution for Reliable, Everyday Energy
//                   Storage!
//                 </label>
//                 <h4 className="title-2">Description</h4>
//                 <p>
//                   The ATP Series solar storage inverters offer top-tier
//                   efficiency and reliability with advanced MPPT technology and
//                   seamless Li-ion battery integration. With a pure sine wave
//                   output, modern aesthetics, and user-friendly design, they
//                   ensure cost-saving performance.
//                 </p>

//                 <h5 className="title-2">
//                   ATP: Inverter Technical Specifications
//                 </h5>
//                 <p>MODEL ATP-10K-SP</p>

//                 <h4 className="title-2">Battery Specifications</h4>

//                 <div className="specifications">
//                   {/* OFF-GRID OUTPUT */}
//                   <h4 className="title-2">OFF-GRID OUTPUT</h4>
//                   <div
//                     className="property-detail-info-list section-bg-1 clearfix mb-60"
//                     style={{ display: "flex", gap: "20px" }}
//                   >
//                     <ul style={{ flex: "1" }}>
//                       <li>
//                         <label>Rated Output Power:</label> <span>6,000W</span>
//                       </li>
//                       <li>
//                         <label>Max. Peak Power:</label> <span>12,000VA</span>
//                       </li>
//                       <li>
//                         <label>Rated Output Voltage:</label>{" "}
//                         <span>230Vac single-phase</span>
//                       </li>
//                     </ul>
//                     <ul style={{ flex: "1" }}>
//                       <li>
//                         <label>Load Capacity of Motors:</label> <span>4HP</span>
//                       </li>
//                       <li>
//                         <label>Output Frequency:</label>{" "}
//                         <span>50Hz ± 0.3Hz / 60Hz ± 0.3Hz</span>
//                       </li>
//                     </ul>
//                   </div>

//                   {/* ON-GRID OUTPUT */}
//                   <h4 className="title-2">ON-GRID OUTPUT</h4>
//                   <div
//                     className="property-detail-info-list section-bg-1 clearfix mb-60"
//                     style={{ display: "flex", gap: "20px" }}
//                   >
//                     <ul style={{ flex: "1" }}>
//                       <li>
//                         <label>Rated Output Power:</label> <span>6,000W</span>
//                       </li>
//                       <li>
//                         <label>Max. Apparent Power:</label>{" "}
//                         <span>12,000VA</span>
//                       </li>
//                       <li>
//                         <label>Rated Output Current:</label> <span>26A</span>
//                       </li>
//                       <li>
//                         <label>Max. Output Current:</label> <span>28.6A</span>
//                       </li>
//                     </ul>
//                     <ul style={{ flex: "1" }}>
//                       <li>
//                         <label>THDI:</label> <span>&lt; 3%</span>
//                       </li>
//                       <li>
//                         <label>Power Factor:</label>{" "}
//                         <span>0.8 leading to 0.8 lagging</span>
//                       </li>
//                       <li>
//                         <label>Rated Voltage:</label>{" "}
//                         <span>230Vac, single phase</span>
//                       </li>
//                       <li>
//                         <label>Frequency:</label> <span>50Hz / 60Hz</span>
//                       </li>
//                     </ul>
//                   </div>

//                   {/* BATTERY */}
//                   <h4 className="title-2">BATTERY</h4>
//                   <div
//                     className="property-detail-info-list section-bg-1 clearfix mb-60"
//                     style={{ display: "flex", gap: "20px" }}
//                   >
//                     <ul style={{ flex: "1" }}>
//                       <li>
//                         <label>Battery Type:</label>{" "}
//                         <span>Lead-acid / Li-ion / User Defined</span>
//                       </li>
//                       <li>
//                         <label>Rated Battery Voltage:</label>{" "}
//                         <span>48V (minimum start-up voltage 44V)</span>
//                       </li>
//                       <li>
//                         <label>Battery Voltage Range:</label>{" "}
//                         <span>40~60Vdc</span>
//                       </li>
//                     </ul>
//                     <ul style={{ flex: "1" }}>
//                       <li>
//                         <label>Max. PV Charging Current:</label>{" "}
//                         <span>100A</span>
//                       </li>
//                       <li>
//                         <label>Max. Utility Charging Current:</label>{" "}
//                         <span>60A</span>
//                       </li>
//                       <li>
//                         <label>Max. Generator Charging Current:</label>{" "}
//                         <span>60A</span>
//                       </li>
//                     </ul>
//                   </div>

//                   {/* PV INPUT */}
//                   <h4 className="title-2">PV INPUT</h4>
//                   <div
//                     className="property-detail-info-list section-bg-1 clearfix mb-60"
//                     style={{ display: "flex", gap: "20px" }}
//                   >
//                     <ul style={{ flex: "1" }}>
//                       <li>
//                         <label>Num. of MPPT Trackers:</label> <span>2</span>
//                       </li>
//                       <li>
//                         <label>Max. PV Array Power:</label>{" "}
//                         <span>5,500W + 5,500W</span>
//                       </li>
//                       <li>
//                         <label>Max. Input Current:</label>{" "}
//                         <span>16A + 16A</span>
//                       </li>
//                     </ul>
//                     <ul style={{ flex: "1" }}>
//                       <li>
//                         <label>Max. Short-circuit Current:</label>{" "}
//                         <span>27A + 27A</span>
//                       </li>
//                       <li>
//                         <label>Max. Open-circuit Voltage:</label>{" "}
//                         <span>500Vdc + 500Vdc</span>
//                       </li>
//                       <li>
//                         <label>MPPT Operating:</label> <span>120~450Vdc</span>
//                       </li>
//                     </ul>
//                   </div>

//                   {/* UTILITY / GENERATOR INPUT */}
//                   <h4 className="title-2">UTILITY / GENERATOR INPUT</h4>
//                   <div
//                     className="property-detail-info-list section-bg-1 clearfix mb-60"
//                     style={{ display: "flex", gap: "20px" }}
//                   >
//                     <ul style={{ flex: "1" }}>
//                       <li>
//                         <label>Input Voltage Range:</label>{" "}
//                         <span>90~280Vac</span>
//                       </li>
//                       <li>
//                         <label>Frequency Range:</label> <span>50/60Hz</span>
//                       </li>
//                       <li>
//                         <label>Bypass Overload Current:</label> <span>40A</span>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>

//                 {/* <div className="property-detail-feature-list clearfix mb-45">
//                   <ul>
//                     <li>
//                       <div className="property-detail-feature-list-item">
//                         <i className="flaticon-double-bed" />
//                         <div>
//                           <h6>Living Room</h6>
//                           <small>20 x 16 sq feet</small>
//                         </div>
//                       </div>
//                     </li>
//                     <li>
//                       <div className="property-detail-feature-list-item">
//                         <i className="flaticon-double-bed" />
//                         <div>
//                           <h6>Garage</h6>
//                           <small>20 x 16 sq feet</small>
//                         </div>
//                       </div>
//                     </li>
//                     <li>
//                       <div className="property-detail-feature-list-item">
//                         <i className="flaticon-double-bed" />
//                         <div>
//                           <h6>Dining Area</h6>
//                           <small>20 x 16 sq feet</small>
//                         </div>
//                       </div>
//                     </li>
//                     <li>
//                       <div className="property-detail-feature-list-item">
//                         <i className="flaticon-double-bed" />
//                         <div>
//                           <h6>Bedroom</h6>
//                           <small>20 x 16 sq feet</small>
//                         </div>
//                       </div>
//                     </li>
//                     <li>
//                       <div className="property-detail-feature-list-item">
//                         <i className="flaticon-double-bed" />
//                         <div>
//                           <h6>Bathroom</h6>
//                           <small>20 x 16 sq feet</small>
//                         </div>
//                       </div>
//                     </li>
//                     <li>
//                       <div className="property-detail-feature-list-item">
//                         <i className="flaticon-double-bed" />
//                         <div>
//                           <h6>Gym Area</h6>
//                           <small>20 x 16 sq feet</small>
//                         </div>
//                       </div>
//                     </li>
//                     <li>
//                       <div className="property-detail-feature-list-item">
//                         <i className="flaticon-double-bed" />
//                         <div>
//                           <h6>Garden</h6>
//                           <small>20 x 16 sq feet</small>
//                         </div>
//                       </div>
//                     </li>
//                     <li>
//                       <div className="property-detail-feature-list-item">
//                         <i className="flaticon-double-bed" />
//                         <div>
//                           <h6>Parking</h6>
//                           <small>20 x 16 sq feet</small>
//                         </div>
//                       </div>
//                     </li>
//                   </ul>
//                 </div> */}
//                 <h4 className="title-2">From Our Gallery</h4>
//                 <div className="ltn__property-details-gallery mb-30">
//                   <div className="row">
//                     <div className="col-md-6">
//                       {/* <a
//                         href={publicUrl + "assets/img/others/14.jpg"}
//                         data-rel="lightcase:myCollection"
//                       > */}
//                       <img
//                         className="mb-30"
//                         src={
//                           publicUrl + "assets/img/others/inverter-gallery-1.jpg"
//                         }
//                         alt="Image"
//                       />
//                       {/* </a> */}
//                       {/* <a
//                         href={publicUrl + "assets/img/others/15.jpg"}
//                         data-rel="lightcase:myCollection"
//                       > */}
//                       <img
//                         className="mb-30"
//                         src={
//                           publicUrl + "assets/img/others/inverter-gallery-2.jpg"
//                         }
//                         alt="Image"
//                       />
//                       {/* </a> */}
//                     </div>
//                     <div className="col-md-6">
//                       {/* <a
//                         href={publicUrl + "assets/img/others/16.jpg"}
//                         data-rel="lightcase:myCollection"
//                       > */}
//                       <img
//                         className="mb-30"
//                         src={
//                           publicUrl + "assets/img/others/inverter-gallery-3.jpg"
//                         }
//                         alt="Image"
//                       />
//                       {/* </a> */}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// export default SolarInverterDetails;

import React from "react";
import { useParams } from "react-router-dom";
import { Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";
import CategoryInverters from "../section-components/category-inverters";
import ProductOverview from "./product-overview";

const SolarInverterDetails = ({ inverter }) => {
  let modelId = inverter?.id;
  let publicUrl = process.env.PUBLIC_URL + "/";
  if (!inverter) {
    return <h2 className="text-center mt-5">Product not found</h2>;
  }

  const handleDownload = (fileName) => {
    const link = document.createElement("a");
    link.href = `/brochures/${fileName}`; // Path to the PDF file in public folder
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleUserManualDownload = (modelId) => {
    let fileName = "Inverter-User-Manual.pdf"; // Default fallback

    if (modelId === "atp-3k-sp") {
      fileName = "3.5kW-Inverter-User-Manual.pdf";
    } else if (modelId === "atp-6k-sp") {
      fileName = "6kW-Inverter-User-Manual.pdf";
    } else if (modelId === "atp-10k-sp") {
      fileName = "10kW-Inverter-User-Manual.pdf";
    } else if (modelId === "atp-12k-h3p") {
      fileName = "12kW-Inverter-User-Manual.pdf";
    }

    const link = document.createElement("a");
    link.href = `/brochures/${fileName}`; // Path to the PDF file in public folder
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <div className="ltn__shop-details-area pb-10">
        <div className="container">
          <ProductOverview overview={inverter?.productOverview} />
          <div className="row">
            <div className="col-lg-8 col-md-12">
              <div className="ltn__shop-details-inner ltn__page-details-inner mb-60">
                {/* <div className="ltn__blog-meta">
                  <ul>
                    <li className="ltn__blog-category">
                      <span>Power your life with Atom Power</span>
                    </li>
                    <li className="ltn__blog-category bg-orange">
                      <span>ATP Series Solar Inverters</span>
                    </li>
                  </ul>
                </div> */}

                <div className="ltn__blog-meta mt-2">
                  <ul>
                    <li style={{ marginBottom: "6px" }}>
                      <button
                        onClick={() => handleDownload("inverter-flyer.pdf")} // Replace with actual file name
                        className="btn btn-success d-flex align-items-center"
                        style={{
                          gap: "10px",
                          fontWeight: "light",
                          padding: "10px 15px",
                          backgroundColor: "red",
                          border: "none",
                        }}
                      >
                        Download Brochure
                        <i
                          className="fas fa-download"
                          style={{ color: "white" }}
                        ></i>
                      </button>
                    </li>

                    <li>
                      <button
                        onClick={() => handleUserManualDownload(modelId)} // Replace with actual file name
                        className="btn btn-success d-flex align-items-center"
                        style={{
                          gap: "10px",
                          fontWeight: "light",
                          padding: "10px 15px",
                          backgroundColor: "red",
                          border: "none",
                        }}
                      >
                        Download User Manual
                        <i
                          className="fas fa-download"
                          style={{ color: "white" }}
                        ></i>
                      </button>
                    </li>
                  </ul>
                </div>

                <h1>Solar Inverter : {inverter.name}</h1>
                {/* <label>
                  <span className="ltn__secondary-color">
                    <i className="flaticon-pin" />
                  </span>
                  A Smart Battery Solution for Reliable, Everyday Energy
                  Storage!
                </label> */}
                <h4>Description</h4>
                <p>{inverter.description}</p>

                <h4>Technical Specifications</h4>
                <Accordion defaultActiveKey="0">
                  {Object.entries(inverter.specifications).map(
                    ([category, details], index) => (
                      <Accordion.Item
                        eventKey={index.toString()}
                        key={category}
                      >
                        <Accordion.Header className="fw-bold">
                          {category}
                        </Accordion.Header>
                        <Accordion.Body>
                          <ul className="list-group list-group-flush">
                            {Object.entries(details).map(([key, value]) => (
                              <li
                                key={key}
                                className="list-group-item d-flex justify-content-between"
                              >
                                <span className="fw-bold">{key}:</span>{" "}
                                <span>{value}</span>
                              </li>
                            ))}
                          </ul>
                        </Accordion.Body>
                      </Accordion.Item>
                    )
                  )}
                </Accordion>

                <h4 className="mt-5">From Our Gallery</h4>
                <div className="ltn__property-details-gallery mb-30">
                  <div className="row">
                    {inverter.gallery.map((image, index) => (
                      <div className="col-md-4 mt-3" key={index}>
                        <img
                          src={image}
                          alt="Gallery Image"
                          className="img-fluid rounded shadow-sm border p-2"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-12">
              <aside className="sidebar ltn__shop-sidebar ltn__right-sidebar---">
                {/* Author Widget */}
                {/* <div className="widget ltn__author-widget">
                  <div className="ltn__author-widget-inner text-center">
                    <img
                      src={publicUrl + "assets/img/team/4.jpg"}
                      alt="Image"
                    />
                    <h5>Rosalina D. Willaimson</h5>
                    <small>Traveller/Photographer</small>
                    <div className="product-ratting">
                      <ul>
                        <li>
                          <a href="#">
                            <i className="fas fa-star" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fas fa-star" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fas fa-star" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fas fa-star-half-alt" />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="far fa-star" />
                          </a>
                        </li>
                        <li className="review-total">
                          {" "}
                          <a href="#"> ( 1 Reviews )</a>
                        </li>
                      </ul>
                    </div>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Veritatis distinctio, odio, eligendi suscipit
                      reprehenderit atque.
                    </p>
                    <div className="ltn__social-media">
                      <ul>
                        <li>
                          <a href="#" title="Facebook">
                            <i className="fab fa-facebook-f" />
                          </a>
                        </li>
                        <li>
                          <a href="#" title="Twitter">
                            <i className="fab fa-twitter" />
                          </a>
                        </li>
                        <li>
                          <a href="#" title="Linkedin">
                            <i className="fab fa-linkedin" />
                          </a>
                        </li>
                        <li>
                          <a href="#" title="Youtube">
                            <i className="fab fa-youtube" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div> */}
                {/* Search Widget */}
                {/* <div className="widget ltn__search-widget">
                  <h4 className="ltn__widget-title ltn__widget-title-border-2">
                    Search Objects
                  </h4>
                  <form action="#">
                    <input
                      type="text"
                      name="search"
                      placeholder="Search your keyword..."
                    />
                    <button type="submit">
                      <i className="fas fa-search" />
                    </button>
                  </form>
                </div> */}
                {/* Form Widget */}
                {/* <div className="widget ltn__form-widget">
                  <h4 className="ltn__widget-title ltn__widget-title-border-2">
                    Drop Messege For Book
                  </h4>
                  <form action="#">
                    <input
                      type="text"
                      name="yourname"
                      placeholder="Your Name*"
                    />
                    <input
                      type="text"
                      name="youremail"
                      placeholder="Your e-Mail*"
                    />
                    <textarea
                      name="yourmessage"
                      placeholder="Write Message..."
                      defaultValue={""}
                    />
                    <button type="submit" className="btn theme-btn-1">
                      Send Messege
                    </button>
                  </form>
                </div> */}
                {/* Top Rated Product Widget */}
                {/* <div className="widget ltn__top-rated-product-widget go-top">
                  <h4 className="ltn__widget-title ltn__widget-title-border-2">
                    Top Rated Product
                  </h4>
                  <ul>
                    <li>
                      <div className="top-rated-product-item clearfix">
                        <div className="top-rated-product-img">
                          <Link to="/product-details">
                            <img
                              src={publicUrl + "assets/img/product/1.png"}
                              alt="#"
                            />
                          </Link>
                        </div>
                        <div className="top-rated-product-info">
                          <div className="product-ratting">
                            <ul>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                            </ul>
                          </div>
                          <h6>
                            <Link to="/shop">Luxury House In Greenville </Link>
                          </h6>
                          <div className="product-price">
                            <span>$30,000.00</span>
                            <del>$35,000.00</del>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="top-rated-product-item clearfix">
                        <div className="top-rated-product-img">
                          <Link to="/product-details">
                            <img
                              src={publicUrl + "assets/img/product/2.png"}
                              alt="#"
                            />
                          </Link>
                        </div>
                        <div className="top-rated-product-info">
                          <div className="product-ratting">
                            <ul>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                            </ul>
                          </div>
                          <h6>
                            <Link to="/shop">Apartment with Subunits</Link>
                          </h6>
                          <div className="product-price">
                            <span>$30,000.00</span>
                            <del>$35,000.00</del>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="top-rated-product-item clearfix">
                        <div className="top-rated-product-img">
                          <Link to="/product-details">
                            <img
                              src={publicUrl + "assets/img/product/3.png"}
                              alt="#"
                            />
                          </Link>
                        </div>
                        <div className="top-rated-product-info">
                          <div className="product-ratting">
                            <ul>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="fas fa-star-half-alt" />
                                </a>
                              </li>
                              <li>
                                <a href="#">
                                  <i className="far fa-star" />
                                </a>
                              </li>
                            </ul>
                          </div>
                          <h6>
                            <Link to="/shop">3 Rooms Manhattan</Link>
                          </h6>
                          <div className="product-price">
                            <span>$30,000.00</span>
                            <del>$35,000.00</del>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div> */}
                {/* Menu Widget (Category) */}
                {/* <div className="widget ltn__menu-widget ltn__menu-widget-2--- ltn__menu-widget-2-color-2---">
                  <h4 className="ltn__widget-title ltn__widget-title-border-2">
                    Top Categories
                  </h4>
                  <ul className="go-top">
                    <li>
                      <Link to="/blog-grid">
                        Apartments <span>(26)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">
                        Picture Stodio <span>(30)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">
                        Office <span>(71)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">
                        Luxary Vilas <span>(56)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">
                        Duplex House <span>(60)</span>
                      </Link>
                    </li>
                  </ul>
                </div> */}
                {/* Popular Product Widget */}
                <div className="widget ltn__popular-product-widget">
                  <h4 className="ltn__widget-title ltn__widget-title-border-2">
                    Smart Remote Monitoring Platform
                  </h4>
                  <div className="row ltn__popular-product-widget-active slick-arrow-1">
                    {/* ltn__product-item */}
                    <div className="col-12">
                      <div className="ltn__product-item ltn__product-item-4 ltn__product-item-5 text-center---">
                        <div className="product-img go-top">
                          <img
                            src={
                              publicUrl +
                              "assets/img/product-3/solarman.webp"
                            }
                            alt="Smart Remote Monitoring Platform"
                          />
                        </div>
                        <div className="product-info">
                          <p>
                            Effortlessly track your entire solar system's performance and energy flow in real-time using the Smart Monitoring App. Real-Time System Insights, Anytime, Anywhere, putting the data you need right in your hands.
                          </p>
                          {/* <div className="product-img-location">
                            <ul>
                              <li>
                                <Link to="/shop">
                                  <i className="flaticon-pin" /> Belmont
                                  Gardens, Chicago
                                </Link>
                              </li>
                            </ul>
                          </div> */}
                          {/* <ul className="ltn__list-item-2--- ltn__list-item-2-before--- ltn__plot-brief">
                            <li>
                              <span>3 </span>
                              Bedrooms
                            </li>
                            <li>
                              <span>2 </span>
                              Bathrooms
                            </li>
                            <li>
                              <span>3450 </span>
                              square Ft
                            </li>
                          </ul> */}
                        </div>
                      </div>
                    </div>
                    {/* ltn__product-item */}
                    {/* <div className="col-12">
                      <div className="ltn__product-item ltn__product-item-4 ltn__product-item-5 text-center---">
                        <div className="product-img">
                          <a href="product-details.html">
                            <img
                              src={publicUrl + "assets/img/product-3/4.jpg"}
                              alt="#"
                            />
                          </a>
                          <div className="real-estate-agent">
                            <div className="agent-img">
                              <Link to="/team-details">
                                <img
                                  src={publicUrl + "assets/img/blog/author.jpg"}
                                  alt="#"
                                />
                              </Link>
                            </div>
                          </div>
                        </div>
                        <div className="product-info">
                          <div className="product-price">
                            <span>
                              $349,00<label>/Month</label>
                            </span>
                          </div>
                          <h2 className="product-title">
                            <a href="product-details.html">
                              New Apartment Nice View
                            </a>
                          </h2>
                          <div className="product-img-location">
                            <ul>
                              <li>
                                <a href="product-details.html">
                                  <i className="flaticon-pin" /> Belmont
                                  Gardens, Chicago
                                </a>
                              </li>
                            </ul>
                          </div>
                          <ul className="ltn__list-item-2--- ltn__list-item-2-before--- ltn__plot-brief">
                            <li>
                              <span>3 </span>
                              Bedrooms
                            </li>
                            <li>
                              <span>2 </span>
                              Bathrooms
                            </li>
                            <li>
                              <span>3450 </span>
                              square Ft
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div> */}
                    {/* ltn__product-item */}
                    {/* <div className="col-12">
                      <div className="ltn__product-item ltn__product-item-4 ltn__product-item-5 text-center---">
                        <div className="product-img">
                          <a href="product-details.html">
                            <img
                              src={publicUrl + "assets/img/product-3/5.jpg"}
                              alt="#"
                            />
                          </a>
                          <div className="real-estate-agent">
                            <div className="agent-img">
                              <Link to="/team-details">
                                <img
                                  src={publicUrl + "assets/img/blog/author.jpg"}
                                  alt="#"
                                />
                              </Link>
                            </div>
                          </div>
                        </div>
                        <div className="product-info">
                          <div className="product-price">
                            <span>
                              $349,00<label>/Month</label>
                            </span>
                          </div>
                          <h2 className="product-title">
                            <a href="product-details.html">
                              New Apartment Nice View
                            </a>
                          </h2>
                          <div className="product-img-location">
                            <ul>
                              <li>
                                <a href="product-details.html">
                                  <i className="flaticon-pin" /> Belmont
                                  Gardens, Chicago
                                </a>
                              </li>
                            </ul>
                          </div>
                          <ul className="ltn__list-item-2--- ltn__list-item-2-before--- ltn__plot-brief">
                            <li>
                              <span>3 </span>
                              Bedrooms
                            </li>
                            <li>
                              <span>2 </span>
                              Bathrooms
                            </li>
                            <li>
                              <span>3450 </span>
                              square Ft
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div> */}
                    {/*  */}
                  </div>
                </div>
                {/* Popular Post Widget */}
                {/* <div className="widget ltn__popular-post-widget go-top">
                  <h4 className="ltn__widget-title ltn__widget-title-border-2">
                    Leatest Blogs
                  </h4>
                  <ul>
                    <li>
                      <div className="popular-post-widget-item clearfix">
                        <div className="popular-post-widget-img">
                          <Link to="/blog-details">
                            <img
                              src={publicUrl + "assets/img/team/5.jpg"}
                              alt="#"
                            />
                          </Link>
                        </div>
                        <div className="popular-post-widget-brief">
                          <h6>
                            <Link to="/blog-details">
                              Lorem ipsum dolor sit cing elit, sed do.
                            </Link>
                          </h6>
                          <div className="ltn__blog-meta">
                            <ul>
                              <li className="ltn__blog-date">
                                <a href="#">
                                  <i className="far fa-calendar-alt" />
                                  June 22, 2020
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="popular-post-widget-item clearfix">
                        <div className="popular-post-widget-img">
                          <Link to="/blog-details">
                            <img
                              src={publicUrl + "assets/img/team/6.jpg"}
                              alt="#"
                            />
                          </Link>
                        </div>
                        <div className="popular-post-widget-brief">
                          <h6>
                            <Link to="/blog-details">
                              Lorem ipsum dolor sit cing elit, sed do.
                            </Link>
                          </h6>
                          <div className="ltn__blog-meta">
                            <ul>
                              <li className="ltn__blog-date">
                                <a href="#">
                                  <i className="far fa-calendar-alt" />
                                  June 22, 2020
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="popular-post-widget-item clearfix">
                        <div className="popular-post-widget-img">
                          <Link to="/blog-details">
                            <img
                              src={publicUrl + "assets/img/team/7.jpg"}
                              alt="#"
                            />
                          </Link>
                        </div>
                        <div className="popular-post-widget-brief">
                          <h6>
                            <Link to="/blog-details">
                              Lorem ipsum dolor sit cing elit, sed do.
                            </Link>
                          </h6>
                          <div className="ltn__blog-meta">
                            <ul>
                              <li className="ltn__blog-date">
                                <a href="#">
                                  <i className="far fa-calendar-alt" />
                                  June 22, 2020
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="popular-post-widget-item clearfix">
                        <div className="popular-post-widget-img">
                          <Link to="/blog-details">
                            <img
                              src={publicUrl + "assets/img/team/8.jpg"}
                              alt="#"
                            />
                          </Link>
                        </div>
                        <div className="popular-post-widget-brief">
                          <h6>
                            <Link to="/blog-details">
                              Lorem ipsum dolor sit cing elit, sed do.
                            </Link>
                          </h6>
                          <div className="ltn__blog-meta">
                            <ul>
                              <li className="ltn__blog-date">
                                <a href="#">
                                  <i className="far fa-calendar-alt" />
                                  June 22, 2020
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div> */}
                {/* Social Media Widget */}
                {/* <div className="widget ltn__social-media-widget">
                  <h4 className="ltn__widget-title ltn__widget-title-border-2">
                    Follow us
                  </h4>
                  <div className="ltn__social-media-2">
                    <ul>
                      <li>
                        <a href="#" title="Facebook">
                          <i className="fab fa-facebook-f" />
                        </a>
                      </li>
                      <li>
                        <a href="#" title="Twitter">
                          <i className="fab fa-twitter" />
                        </a>
                      </li>
                      <li>
                        <a href="#" title="Linkedin">
                          <i className="fab fa-linkedin" />
                        </a>
                      </li>
                      <li>
                        <a href="#" title="Instagram">
                          <i className="fab fa-instagram" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div> */}
                {/* Tagcloud Widget */}
                {/* <div className="widget ltn__tagcloud-widget go-top">
                  <h4 className="ltn__widget-title ltn__widget-title-border-2">
                    Popular Tags
                  </h4>
                  <ul>
                    <li>
                      <Link to="/blog-grid">Popular</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">desgin</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">ux</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">usability</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">develop</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">icon</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">Car</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">Service</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">Repairs</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">Auto Parts</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">Oil</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">Dealer</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">Oil Change</Link>
                    </li>
                    <li>
                      <Link to="/blog-grid">Body Color</Link>
                    </li>
                  </ul>
                </div> */}
                {/* Banner Widget */}
                {/* <div className="widget ltn__banner-widget d-none go-top">
                  <Link to="/shop">
                    <img src={publicUrl + "assets/img/banner/2.jpg"} alt="#" />
                  </Link>
                </div> */}
              </aside>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SolarInverterDetails;
